import React,{useEffect} from "react";

function Redirector(props) {
  
    useEffect(() => {
      window.location.href = sessionStorage.getItem("returnUrl");
      }, []);
    return(
        <></>
    );
}
export default Redirector;
